import Sharing from "./components/sharing";
import SharingField from "./components/sharing-field";
import SharingForm from "./components/sharing-form";
Sharing.Form = SharingForm;
Sharing.Field = SharingField;
export default Sharing;
//# sourceMappingURL=index.js.map